import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import * as permissionKind from '../../../../shared/permissions';
import { useGetUserQuery } from '../../../api/queries/getUser';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import { useCompanies, useCompany } from '../../../components/contexts/CompanyContextManager';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import hasPermissions from '../../../utilities/hasPermissions';
import UserInnerPage from './UserInnerPage';

const UserViewPage = () => {
    const { userId } = useParams<{ userId: string }>();
    const company = useCompany(true);
    const companies = useCompanies(true);

    const filter = useMemo(() => {
        if (companies?.length) {
            return { companyIds: companies.map(item => item.id) };
        }

        return undefined;
    }, [companies]);

    const { data, loading } = useGetUserQuery({
        fetchPolicy: 'cache-and-network',
        variables: { userId, filter },
    });

    const { permissions: accountPermissions } = useAccount();

    const hasPermission = company
        ? hasPermissions(company.permissions, [permissionKind.viewUsers]) &&
          hasPermissions(accountPermissions, [permissionKind.viewUsers])
        : hasPermissions(accountPermissions, [permissionKind.viewUsers]);

    const user = data?.user;

    if (!user && loading) {
        return <LoadingElement />;
    }

    if (!user || !hasPermission) {
        return <NotFoundResult />;
    }

    return <UserInnerPage user={user} />;
};

export default UserViewPage;
